enum FormErrorType {
	REQUIRED = 'required',
	PATTERN = 'pattern',
	MIN_LENGTH = 'minLength',
	UNAUTHORIZED = 'Unauthorized',
	BAD_USER_INPUT = 'BAD_USER_INPUT',
}

export default FormErrorType;
